import Component from 'gia/Component';

export default class Module extends Component
{
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {}
    this.DOM.view = this.element

    $('#mc-embedded-subscribe-form').submit(function(){
      //show loading
      // $('.loading').show();

      //error message
      var emailErrors = false;
      $('#mc-embedded-subscribe-form .error').html('').hide();

      //disable fields
      $('#mc-embedded-subscribe-form input').addClass('disabled').attr('disabled', 'disabled');
      $('#mc-embedded-subscribe-form button').addClass('disabled').attr('disabled', 'disabled');

      //remove error highlight
      $('#mce-EMAIL').parent().removeClass('has-error');

      //validate email
      var email = $('#mce-EMAIL').val();
      if(email == null || email == undefined || email == '' || !validateEmail(email)) {
        emailErrors = true;
      }


      //form submit
      if(!emailErrors) { //no errors

        //ajax
      $.ajax({
            type: $('#mc-embedded-subscribe-form').attr('method'),
            url: $('#mc-embedded-subscribe-form').attr('action'),
            data: { EMAIL: $('#mce-EMAIL').val() },
            cache       : false,
            dataType    : 'json',
            contentType: "application/json; charset=utf-8",
            error       : function(err) { alert('Could not connect to the registration server. Please try again later.'); },
            success     : function(data) {
          //show loading
          // $('.loading').hide();

        if (data.result != 'success') {
           //enable fields
            $('#mc-embedded-subscribe-form input').removeClass('disabled').removeAttr('disabled');
            $('#mc-embedded-subscribe-form button').removeClass('disabled').removeAttr('disabled');

            //display message
            $('#mc-embedded-subscribe-form .error').html(data.msg).show();
        } else {
           //hide fields
            // $('#mc-embedded-subscribe-form input').hide();
            // $('#mc-embedded-subscribe-form button').hide();

            //display message
            $('#mc-embedded-subscribe-form .success').html(data.msg).show();
            setTimeout(() => {
              $('#mc-embedded-subscribe-form')[0].reset()
              $('#mc-embedded-subscribe-form .success').html('').hide();
              $('#mc-embedded-subscribe-form input').removeClass('disabled').removeAttr('disabled');
              $('#mc-embedded-subscribe-form button').removeClass('disabled').removeAttr('disabled');
            }, 2000);

        }
            }
        });
      } else { //show errors
        //show loading
        // $('.loading').hide();

        //enable fields
        $('#mc-embedded-subscribe-form input').removeClass('disabled').removeAttr('disabled');
        $('#mc-embedded-subscribe-form button').removeClass('disabled').removeAttr('disabled');

        //show error highlight
        $('#mce-EMAIL').parent().addClass('has-error');

        //display message
        $('#mc-embedded-subscribe-form .error').html('Please enter a valid email address').show();
      }
      return false;
    });

    function validateEmail(email) {
      var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
      return re.test(email);
    }
  }



  unmount()
  {

  }
}
